import { AnalyticsInterface } from '../../types/Analytics';
import { EVENT_KEYS } from 'constants-events';

type VisitorManagementEvent = {
  userId: string;
  channelId: string;
  integrationId?: string;
  analytics: AnalyticsInterface;
};

type VisitCreatedEvent = VisitorManagementEvent;

export function emitVisitCreated({
  userId,
  channelId,
  integrationId,
  analytics,
}: VisitCreatedEvent) {
  // FIXME: Event sent as analytic
  // @ts-ignore
  analytics.track(EVENT_KEYS.EVENT_VISIT_CREATED, {
    userId,
    channelId,
    integrationId,
  });
}
